import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { ReactNode, useEffect, useRef, useState } from "react";
interface Props {
  onClose: () => void;
  openModal: boolean;
  children: ReactNode;
  isBigModalPx?: number;
}

export const ModalOverlay = ({ onClose, openModal, children, isBigModalPx }: Props) => {
  const handleOverlayClick = () => {
    onClose();
  };
  const { height } = useWindowSize();
  const smallScreenHeight = height && height < 660

  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [openModal]);

  if (!openModal) return null;

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        padding: "0 16px",
        backgroundColor: "rgba(255, 255, 255, 0.64)",
        position: "fixed",
        top: 0,
        zIndex: 100,
        backdropFilter: "blur(24px)",

        display: "flex",
        justifyContent: "center",
        alignItems: smallScreenHeight? "start" : "center",
        overflow: smallScreenHeight? "auto" : "hidden",
        ...(isBigModalPx && {
          [`@media (max-height: ${isBigModalPx}px)`]: {
            alignItems: 'flex-start',
            overflowY: 'scroll'
          }
        })
      }}
      onClick={handleOverlayClick}
    >
      {children}
    </Box>
  );
};
